import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MessagesModule } from 'primeng/messages';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from "../../shared/shared.module";
import { AuthModule } from '../../auth/auth.module';

import { PassaggioConsegneComponent } from './passaggio-consegne.component';
import { PassaggioConsegneDisplayItemsComponent } from './components/display-items.component';
import { PassaggioConsegneService } from './services/passaggio-consegne.service';
import { InputTextModule } from 'primeng/inputtext';
import { PassaggioAggiuntaDialogComponent } from './components/passaggio-aggiunta-dialog.component';
import { CalendarModule } from 'primeng/calendar';
import { PassaggioDownloadModuloDialog } from './components/passaggio-download-modulo-dialog';
import { DropdownModule } from 'primeng/dropdown';
import { AccordionModule } from 'primeng/accordion';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SelectButtonModule } from 'primeng/selectbutton';
import { PassaggioConsegneModuliBuilderService } from './services/passaggio-consegne-moduli-builder.service';


@NgModule({
  declarations: [
    PassaggioConsegneComponent,
    PassaggioConsegneDisplayItemsComponent,
    PassaggioAggiuntaDialogComponent,
    PassaggioDownloadModuloDialog,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    TableModule,
    DialogModule,
    MessagesModule,
    SharedModule,
    AuthModule,
    InputTextModule,
    CalendarModule,
    DropdownModule,
    AccordionModule,
    InputTextareaModule,
    SelectButtonModule 
],
providers: [
  PassaggioConsegneService,
  PassaggioConsegneModuliBuilderService
]
})
export class PassaggioConsegneModule { }
